import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';
import { whatsappLink } from '../../utils/whatsapp';
export function PromoBanner() {
  const [visible, setVisible] = useState(true);
  const {
    t
  } = useLanguage();
  const p = t.common.promo;
  if (!visible) return null;
  return <div className="relative bg-ink text-white" data-id="element-222" data-mp="2s05lus32uuk">
      <div className="mx-auto flex max-w-7xl items-center justify-center px-12 py-2.5 text-center text-[13px] sm:px-8" data-id="element-223" data-mp="10efo8zw8xyjp">
        <p data-id="element-224" data-mp="vfw1ix9twiqa">
          {p.text} <span className="font-medium text-champagne" data-id="element-225" data-mp="vfcsy762j6ox">{p.highlight}</span> {p.rest}{' '}
          <a href={whatsappLink()} target="_blank" rel="noreferrer" className="font-medium underline underline-offset-4 hover:text-champagne" data-id="element-226" data-mp="qmte76vna5ij">
            {p.cta}
          </a>
        </p>
      </div>
      <button type="button" onClick={() => setVisible(false)} aria-label={p.dismiss} className="absolute right-2 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full text-white/70 transition-colors duration-150 ease-smooth hover:bg-white/10 hover:text-white" data-id="element-227" data-mp="1edyufn5hyztd">
        <XIcon className="h-4 w-4" data-id="element-228" data-mp="dg9vc9emg5rl" />
      </button>
    </div>;
}